import { title } from "process";

export const options = {
  builder: {
    basic: {
      title: 'Componentes Básicos',
      components: {
        password: false,
        button:false
      }
    },
    data:{title: 'Componentes de datos',
    components: {
      //container:false,
      datamap:false,
      datagrid:false,
      editgrid:false,
      tree:false,
      hidden:false
    }},
    premium: {title: 'Componentes Premium',
    components: {
      unknown:false,
      resource:false,
      form: false,
      recaptcha: false

    }},
    advanced: {title: 'Componentes Avanzados',
    components: {
      tags: false,
      address: false,
      day: false,
      survey: false,
      signature:false,
      time: false,
      url:false,
      email:false,
      phoneNumber:false
    }},
    layout: {
      title: 'Componentes de Diseño',
      components: {
        content:false,
        fieldset:false,
        panel:false,
        table:false,
        tabs:false,
        well:false,
        //htmlelement:false

      }
    },
    resource : false,
  },
  editForm: {
  },
  language: 'sp',
  i18n: {
    sp: {
      'Label': 'Etiqueta',
      'Label Position': 'Posición de la etiqueta',
      'Placeholder': 'Valor predeterminado',
      'Description': 'Descripción',
      'Tooltip': 'Texto de Ayuda',
      'Prefix': 'Prefijo',
      'Suffix': 'Sufijo',
      'Widget': 'Widget',
      'Input Mask': 'Máscara de entrada',
      'Custom CSS Class': 'Clase CSS personalizada',
      'Tab Index': 'Tab Index',
      'Hidden ': 'Oculto',
      'Hide Label': 'Ocultar la etiqueta',
      'Show Word Counter': 'Mostrar contador de palabras',
      'Show Character Counter': 'Mostrar contador de caracteres',
      'Hide Input': 'Ocultar Input',
      'Excellent': 'Excelente',
      'Initial Focus': 'Enfoque inicial',
      'Auto Expand':'Auto Expandir',
      'Change': 'Cambio',
      'Allow Spellcheck': 'Permitir revisión ortográfica',
      'Disabled': 'Deshabilitado',
      'Table View': 'Vista de tabla',
      'Modal Edit': 'Modal Edit',
      'Multiple Values': 'Valores múltiples',
      'Persistent': 'persistente',
      'Input Format': 'Formato de entrada',
      'Protected': 'Protegido',
      'Database Index': 'Índice de la base de datos',
      'Mixed (Allow upper and lower case)': 'Mezclado (Permitir mayúsculas y minúsculas)',
      'Uppercase': 'Mayúsculas',
      'Lowercase': 'Minúsculas',
      'Encrypted (Enterprise Only)': 'Cifrado (Sólo Empresa)',
      'Default Value': 'Valor por defecto',
      'Drag and Drop a form component': 'Arrastrar y soltar un componente',
      'Text Field': 'Campo de texto',
      'Email': 'Correo electrónico',
      'Text Area': 'Área de texto',
      'Panel': 'Panel',
      'Time': 'Tiempo',
      'Submit': 'Enviar',
      'Basic Components': 'Componentes básicos',
      'Layout Components': 'Componentes del diseño',
      'Advanced': 'Avanzado',
      'Hidden': 'Oculto',
      'Component': '',
      'Display': 'Mostrar',
      'Data': 'Datos',
      'Validation': 'Validación',
      'API': 'API',
      'Conditional': 'Condicional',
      'Logic': 'Lógica',
      'Layout': 'Diseño',
      'Allow Multiple Masks': 'Permitir varias máscaras',
      'Input Field': 'Campo de entrada',
      'Top': 'Arriba',
      'Left (Left-aligned)': 'Izquierda (alineado a la izquierda)',
      'Input Type': 'Tipo de entrada',
      'Collapsible': 'Colapsable',
      'Preview': 'Previsualización',
      'Text Case': 'Caso de texto',
      'Redraw On': 'Redraw On',
      'Clear Value When Hidden': 'Limpiar cuando se oculta',
      'Custom Default Value': 'Valor predeterminado',
      'Calculated Value': 'Valor calculado',
      'Calculate Value on server': 'Calcular el valor en el servidor',
      'Allow Manual Override of Calculated Value': 'Permitir la anulación manual del valor calculado',
      'Server': 'Servidor',
      'Client': 'Cliente',
      'None': 'Ninguno',
      'Validate On': 'Validar en',
      'Required': 'Requerido',
      'Unique': 'Único',
      'Minimum Length': 'Longitud mínima',
      'Maximum Length': 'Longitud máxima',
      'Minimum Word Length': 'Cantidad mínima de palabras',
      'Maximum Word Length': 'Cantidad máxima de palabras',
      'Regular Expression Pattern': 'Patrón de expresión regular',
      'Error Label': 'Etiqueta de error',
      'Custom Error Message': 'Mensaje de error personalizado',
      'Custom Validation': 'Validación personalizada',
      'JSONLogic Validation': 'Validación JSONLogic',
      'Property Name': 'Nombre de la propiedad',
      'Field Tags': 'Etiquetas Tags',
      'Custom Properties': 'Propiedades personalizadas',
      'Add Another': 'Agregar otro',
      'Save': 'Guardar',
      'Cancel': 'Cancelar',
      'Remove': 'Remover',
      'Edit': 'Editar',
      'Rows': 'Filas',
      'Title': 'Título',
      'Theme': 'Tema',
      'Data Format': 'Formato de datos',
      'Advanced Logic': 'Lógica avanzada',
      'Advanced Conditions': 'Condiciones Avanzadas',
      'Simple': 'Simple',
      'HTML Attributes': 'Atributos HTML',
      'PDF Overlay': 'Overlay PDF',
      'Number': 'Número ',
      'Use Thousands Separator': 'Usar el separador de miles',
      'To add a tooltip to this field, enter text here': 'Para agregar un texto de ayuda, ingrese el texto aquí',
      'Calendar Picker': 'Seleccionar fecha de calendario',
      'Label Width': 'Ancho de etiqueta',
      'Label Margin': 'Margen de etiqueta',
      'Value': 'Valor',
      'Values': 'Valores',
      'Shortcut': 'Atajo',
      'Storage Type':'Tipo de Almacenamiento',
      'Decimal Places': 'Cantidad de Decimales',
      'Require Decimal': 'Requerir Decimal',
      'Minimum Value': 'Valor Mínimo',
      'Maximum Value': 'Valor Máximo',
      'Type to search': 'Escribe para buscar',
      'Minimum checked number': 'Cantidad mínima de casillas marcadas',
      'Maximum checked number': 'Cantidad máxima de casillas marcadas',
      'Minimum checked error message': 'Mensaje de error al no marcar la cantidad de casillas mínimas',
      'Maximum checked error message': 'Mensaje de error al marcar más de la cantidad de casillas máximas',
      'Widget Type': 'Tipo de widget',
      'Unique Options': 'Opción única',
      'Data Source Type': 'Tipo de datos',
      'Data Source Values': 'Valores',
      'ID Path': 'ID ruta',
      'Item Template': 'Plantilla',
      'Refresh Options On': 'Refrescar opciones activas',
      'Clear Value On Refresh Options': 'Borrar valores al refrescar',
      'Enable Static Search': 'Habilitar búsqueda estática',
      'Search Threshold': 'Umbral de búsqueda',
      'Read Only Value': 'Valor de solo lectura',
      'Choices.js options': 'Choices.js opciones',
      'Use exact search': 'Usar búsqueda exacta',
      'Refresh Options On Blur': 'Actualizar opciones en desenfoque',
      'Inline Layout': 'Diseño en línea',
      'Validate this email using the Kickbox email validation service.': 'Validar el correo electrónico utilizando el servicio de validación de correo electrónico de Kickbox.',
      'Enable': 'Habilitar',
      'Display in Timezone':  'Mostrar en zona horaria',
      'Use Locale Settings': 'Usar configuración regional',
      'Allow Manual Input':'Permitir entrada manual',
      'Format':'Formato',
      'Use formats provided by DateParser Codes': '',
      'Enable Date Input' : 'Habilitar entrada de fecha',
      'Use Input to add moment.js for minDate' : 'Use Input para agregar fecha mínima',
      'Use calendar to set minDate': 'Use el calendario para establecer fecha mínima',
      'Use Input to add moment.js for maxDate': 'Use Input para agregar fecha máxima',
      'Use calendar to set maxDate':'Use el calendario para establecer fecha máxima',
      'Disable specific dates or dates by range': 'Deshabilitar fechas específicas o fechas por rango',
      'Disable weekends': 'Deshabilitar fines de semana',
      'Disable weekdays': 'Desactivar los días entre semana',
      'Enable Time Input': 'Habilitar entrada de tiempo',
      'Hour Step Size': 'Tamaño de paso de hora',
      'Minute Step Size': 'Tamaño de paso minuto',
      '12 Hour Time (AM/PM)': '12 horas (AM / PM)',
      'prefix': 'prefijo',
      'suffix':'sufijo',
      'Currency': 'Moneda',
      'Column Properties': 'Propiedades de columna',
      'Size': 'Tamaño',
      'Width': 'Ancho',
      'Offset': 'Compensar',
      'Pull': 'Jalar',
      'Push': 'Empujar',
      'Add Column': 'Agregar Columna',
      'Auto adjust columns': 'Auto ajustar columnas',
      'Hide Column when Children Hidden' : 'Ocultar columna cuando los hijos están ocultos',
      'Type of event': 'Tipo de evento',
      'Form Load': 'Carga de formulario',
      'Button Click': 'Click en botón',
      'File': 'Archivo',
      'Storage': 'Almacenamiento',
      'Directory': 'Directorio',
      'File Name Template': 'Plantilla para nombre del archivo',
      'Display as image(s)': 'Mostrar como imagen(es)',
      'Upload Only': 'Subir Solamente',
      'Enable web camera': 'Habilitar Cámara Web',
      'File Types': 'Tipos de archivo',
      'File Pattern': 'Patron de archivo',
      'File Minimum Size': 'Tamaño mínimo de archivo',
      'File Maximum Size': 'Tamaño máximo de archivo',
      'File Name' : 'Nombre de Archivo',
      'Container': 'Contenedor',
      'container': 'contenedor',
      'No storage has been set for this field. File uploads are disabled until storage is set up.':'No se ha establecido ningún almacenamiento para este campo. Las cargas de archivos están deshabilitadas hasta que se configura el almacenamiento',
      'Removing this component will also remove all of its children. Are you sure you want to do this?':'La eliminación de este componente también eliminará todos sus elementos secundarios. ¿Seguro que quieres hacer esto? ',
      'Submission Complete.':'Envío completado',
      'January':'Enero',
      'November':'Noviembre',
      'December':'Diciembre',
      'Result fields': 'Campos de resultado',
      'No Matches Found': 'No se encontraron coincidencias',
      'API Key is not unique: ':'La API key no es unica:  ',
      'Fecha / Hora': 'Fecha',
      'No results found': 'No se han encontrado resultados',
      'No choices to choose from': 'No hay opciones para elegir',
      'Please fix the following errors before submitting.':'Corrija los siguientes errores antes de enviar. ',
      'Custom': 'OCR'
    }
  }
};
